//Comentario necesario para codificación en UTF-8, ver Inc6743
'use strict';

(function () {
	angular.module('pphhApp')
	.factory("UserService", ["$http", "$window", "$q", UserServiceFactory]);
	
	function UserServiceFactory($http, $window, $q) {
	
		var instance = {
	    	createUser: createUser,
	    	updateUser: updateUser,
	        getAllUsersRegistrados: getAllUsersRegistrados,
	        getAllUsersRegistradosExcel: getAllUsersRegistradosExcel,
	        getRolesUsers: getRolesUsers,
	        getUser: getUser,
	        updateStateUser: updateStateUser,
			getAdmonScope: getAdmonScope
	    };
	
	    return instance;
	
	    function createUser(user) {
			var userParam = angular.copy(user);
			angular.forEach ( userParam.roles, function ( rol ){
			angular.forEach(rol.administrations, function (adm) {
				
				var index = 0;
				while(index < adm.admScope.length) {
					if(adm.admScope[index].checked === false) {
						adm.admScope.splice(index, 1);
					} else {
						adm.admScope[index].id = adm.admScope[index].key;
						delete adm.admScope[index].key;
						delete adm.admScope[index].checked;
						
						index++;
					}
				}
				
			})
			});
		
	    	var request = {
				method: "POST",
				url: _contextPath + "/gdu/user",
				data: userParam
		    };
	    	request.headers = {};
	    	request.headers[_csrf_headerName] = _csrf_token;
	    	return $http(request);
	    }
	
	    function updateUser(user) {
	    	return createUser(user);
	    }
	
	    function getAllUsersRegistrados(filter) {
	    	var params = {};
	    	angular.forEach(filter, function (value, name) {
	    		if(angular.isDefined(value) && value != null) {
	    			params[name] = value;
	    		}
	    	});
	    	
	    	var config = {
	    		method: "GET",
	    		url: _contextPath +"/gdu/users",
	    		params: filter
	    	};
	    	
	    	return $http(config);
	    }
	    
		function buildParamObject(filter) {
			var params = {};
			angular.forEach(filter, function(value, key) {
				if(value != null) {
					params[key] = value;
				}
			});

			return params;
		} 
	    
		function getAllUsersRegistradosExcel(filter) {
		    var url = _contextPath + "/gdu/users/export";
		    
		    var i = 0;
		    var fullFilter = buildParamObject(filter);		
		    angular.forEach(fullFilter, function (value, p) {
		        if (value === "") {
		            return;
		        }
		
		        if (typeof value === "object") {
		            if (Array.isArray(value)) {
		                value = value.map(item => {
		                    if (typeof item === "object") {
		                        return JSON.stringify(item);
		                    }
		                    return item;
		                }).join(",");
		            } else {
		                value = JSON.stringify(value);
		            }
		        }

		        value = encodeURIComponent(value);
		
		        url += (i === 0 ? "?" : "&") + p + "=" + value;
		        i++;
		    });
	
		    $window.open(url);
		}
	
	    function getRolesUsers() {
	    	var deferred = $q.defer();
	        $http.get(_contextPath +"/gdu/roles")
	            .then(
	            function (response) {
	                deferred.resolve(response.data);
	            },
	            function(errResponse){
	                deferred.reject(errResponse);
	            }
	        );
	        return deferred.promise;
	    }
	
	    function getUser(userId) {
	    	var request = {
	    			method: "GET",
	    			url: _contextPath +"/gdu/user/" + userId
	    	};
	
	    	return $http(request);
	    }
	
	    function updateStateUser(id, newState) {
	    	var request = {
	    			method: "POST",
	    			url: _contextPath + "/gdu/user/" + id + "/state/" + newState,
	
			};
	    	request.headers = {};
	    	request.headers[_csrf_headerName] = _csrf_token;
	    	return $http(request);
	    }
	
		function getAdmonScope(admId) {
			var request = {
				method: "GET",
				url: _contextPath + "/gdu/admin/" + admId + "/scope"
			};
			
			return $http(request);
		}
	
	}
})();
